class PasswordShowHide {
  constructor($elem) {
    this.$elem = $elem;
    const showHideButton = $elem;
    this.$targetInput = document.querySelector(showHideButton.dataset.target_input);
    this.passWordShowHideToggle = this.handleInputShowHideClick.bind(this);
  }

  async handleInputShowHideClick() {
    const icon = this.$elem.querySelector("i");
    const tooltip = this.$elem.querySelector(".tooltip");
    const tooltipInner = tooltip.querySelector(".tooltip-inner")
    let showWords = "パスワードを表示する"
    if(this.$targetInput.type == "text"){
      this.$targetInput.type = "password"
      this.$elem.classList.remove("show");
      showWords = "パスワードを表示する"
    }else{
      this.$targetInput.type = "text"
      this.$elem.classList.add("show");
      showWords = "パスワードを非表示にする";
    }
    tooltipInner.innerText = showWords;
    icon.dataset.originalTitle = showWords;
    $('.tooltip').tooltip('show');
  }

  async setEvents() {
    if (this.$elem) {
      this.$elem.addEventListener('click', this.passWordShowHideToggle);
    }
  }

};
export default PasswordShowHide;
